// removed by extract-text-webpack-plugin
module.exports = {"container":"_21tIIO59l3T9WOwwNRtIpA","icon":"vnEiCtc6IhWUbYajOmuka","title":"_1oZtjtzalx231aaPB3RnpB"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/FillNameFields/Title/styles.css
// module id = 2950
// module chunks = 0